import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const LazyContent = lazy(async () => import('../../../content/help/0-index.mdx'));

export const Route = createFileRoute('/verwaltung/hilfe/')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Suspense>
      <LazyContent />
    </Suspense>
  );
}
